import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    "@media (max-width: 540px)": {
      marginLeft: "0",
      marginRight: "0",
      paddingRight: "0%",
      paddingLeft: "0%",
    },
    containerType: "inline-size",
  },

  bookmarkToggle: {
    backgroundColor: tokens.colorNeutralBackground1,

    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },

  filtersRow: {
    ...shorthands.gap("16px"),
    marginBottom: "20px",
    alignSelf: "stretch",
    display: "flex",
    position: "relative",
    "@media (max-width: 540px)": {
      justifyContent: "space-between",
    },
  },

  filtersContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    ...shorthands.gap("0.75rem"),

    "@media (max-width: 540px)": {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      alignSelf: "stretch",
    },
  },

  filterIcon: {
    color: tokens.colorCompoundBrandForeground1,
    width: "24px",
    height: "24px",
  },

  tabList: {
    display: "flex",
    alignItems: "flex-start",
    alignSelf: "stretch",
  },

  cards: {
    // this pixel is needed to show the top border of the cards on the first row
    paddingTop: "1px",
    rowGap: "20px",
    paddingBottom: "11px",
    maxHeight: "calc(100% - 96px)",
    ...shorthands.overflow("auto"),
  },

  increasedRowGap: {
    rowGap: "31px",
  },

  cardCol: {
    "@media (max-width: 1084px)": {
      ...shorthands.flex(0, 0, "33.33333%"),
      maxWidth: "33.33333%",
    },
    "@media (max-width: 627px)": {
      ...shorthands.flex(0, 0, "100%"),
      maxWidth: "100%",
    },
  },

  cardColV2: {
    "@media (min-width: 2560px)": {
      ...shorthands.flex(0, 0, "12.5%"),
      maxWidth: "12.5%",
    },
    "@media (max-width: 2560px) and (min-width: 1920px)": {
      ...shorthands.flex(0, 0, "16.6666667%"),
      maxWidth: "16.6666667%",
    },
    "@media (max-width: 1920px) and (min-width: 1600px)": {
      ...shorthands.flex(0, 0, "20%"),
      maxWidth: "20%",
    },
    "@media (min-width: 948px) and (max-width: 1125px)": {
      ...shorthands.flex(0, 0, "33.33333%"),
      maxWidth: "33.33333%",
    },
    "@media (max-width: 948px) and (min-width: 592px)": {
      ...shorthands.flex(0, 0, "50%"),
      maxWidth: "50%",
    },
    "@media (max-width: 592px)": {
      ...shorthands.flex(0, 0, "100%"),
      maxWidth: "100%",
    },
  },

  metaOSV2ActionCard: {
    maxWidth: "100%",
    flexBasis: "100%",
    width: "100%",
  },

  metaOsV2HomePage: {
    ...shorthands.flex(0, 0, "100%"),
    maxWidth: "100%",
    "@media (min-width: 1500px)": {
      ...shorthands.flex(0, 0, "25%"),
      maxWidth: "25%",
    },
    "@media (max-width: 1500px) and (min-width: 961px)": {
      ...shorthands.flex(0, 0, "50%"),
      maxWidth: "50%",
    },
    "@media (max-width: 960px) and (min-width: 0px)": {
      ...shorthands.flex(0, 0, "100%"),
      maxWidth: "100%",
    },
  },

  footerRow: {
    justifyContent: "center",
  },

  moreButton: {
    color: tokens.colorBrandForeground1,
    ...shorthands.border("1px", "solid", tokens.colorBrandForeground1),
  },

  promptTabRow: {
    marginBottom: "12px",
    marginLeft: "0px",
    marginRight: "0px",
  },

  carousel: {
    ...shorthands.padding("2px", "8px", "4px", "8px"),
    "@media (max-width: 479px)": {
      ...shorthands.padding("2px", "15px", "4px", "1px"),
    },
  },

  headerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: "21px",
  },

  header: {
    width: "300px",

    "> div": {
      marginRight: "4px",
    },
  },

  headerText: {
    fontWeight: 600,
    fontSize: tokens.fontSizeBase400,
    lineHeight: tokens.lineHeightBase400,
  },

  headerIcon: {
    height: "20px",
    width: "20px",
    color: tokens.colorBrandForeground1,
  },

  headerSeeAllButton: {
    margin: "0px",
    padding: "0px",
  },

  headerGoBackButton: {
    margin: "0px",
    padding: "0px",
    fontWeight: "bold",
    justifyContent: "flex-start",

    "> span": {
      padding: "0px",
      margin: "0px",
    },
  },
});
